<template>
  <div>
     <b-form-group label="Story Yükle">
      <b-form-file
        accept="image/jpeg, image/png, image/gif"
        @change="onFileChange"
      />
    </b-form-group> 
    <validation-provider
        v-slot="validationContext"
        name="Story Adı"
        rules="required"
      >
        <b-form-group
          label="Story Adı"
          label-for="campaign_name"
        >
          <b-form-input
            id="campaign_name"
            v-model="localValue.campaign_name"
            :state="getValidationState(validationContext)"
            @input="emitUpdate"
            trim
          />
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>
  </div>
</template>

<script>
import { BFormGroup, BFormInput, BFormFile,BFormInvalidFeedback } from 'bootstrap-vue'
  import { ValidationProvider } from 'vee-validate'

export default {
  components: {
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    ValidationProvider
  },
  props: {
    linkData: { type: Object, required: true }
  },
  data() {
    return {
      localValue: { ...this.linkData }
    }
  },
  watch: {
    linkData: {
      handler(newVal) {
        this.localValue = { ...newVal }
      },
      deep: true
    }
  },
  methods: {
    emitUpdate() {
      this.$emit('update', { ...this.localValue })
    },
    onFileChange(e) {
      const file = e.target.files[0]
      this.localValue.image = file
      this.emitUpdate()
    },
    
    getValidationState(context) {
      if (context) return context.validated ? !context.invalid : null
      return null
    }
  }
}
</script>
